module.exports = __webpack_public_path__ + "img/StaticNotrun.8949fd59.svg";